query allBaseballTeams(
  $first: Int,
  $offset: Int,
  $filter: BaseballTeamFilter,
  ) {
  teams: allBaseballTeams(
      first: $first,
      offset: $offset,
      filter: $filter
    ) {
    nodes {
      teamMappings: baseballTeamMappingsByIntId {
        nodes {
          extId
          extRef
          feed
          mappingId
          mappingType
          createdAt
          createdBy
          updatedAt
          updatedBy
        }
      }
      name
      source
      teamId
    }
    totalCount
  }
}
